import React from 'react';

interface MapTabProps {
  selectedFloor?: string;
  onFloorChange?: (floor: string) => void;
  onRefresh?: () => void;
  onFullscreen?: () => void;
  onSettings?: () => void;
}

const MapTab: React.FC<MapTabProps> = ({
  selectedFloor: _selectedFloor,
  onFloorChange: _onFloorChange,
  onRefresh: _onRefresh,
  onFullscreen: _onFullscreen,
  onSettings: _onSettings
}) => {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h3>地图视图开发中...</h3>
      <p>将支持基于地理位置的空间展示</p>
    </div>
  );
};

export default MapTab;
